import(/* webpackMode: "eager" */ "/Users/apple/Desktop/comverse/comverse-baseapp-next/app/(alfamall)/faq/page.jsx");
